(function () {
    angular.module('tradersyard').component('tyUploadPhotoButton', {
        // language=Angular2Html
        template:
            '<div class="ty-upload-photo-button" ng-click="$ctrl.openFileDialog()">\n    <span class="icon-yard-add-image"></span>\n</div>\n\n<form hidden>\n    <input type="file" ng-model="$ctrl.fileObj" ng-class="$ctrl.uploadInputId" \n           flex-file64\n           flex-end="$ctrl.onFileLoaded($ctrl.fileObj)"\n           flex-onerror="$ctrl.onFileError()"\n           flex-maxsize="{{$ctrl.maxSize}}"\n           accept="{{$ctrl.accept}}">\n</form>\n',
        bindings: {
            errorMessage: '<',
            accept: '<',
            maxSize: '<',
            onFile: '&',
            onError: '&',
        },
        transclude: true,
        controller: UploadPhotoButtonCtrl,
    });

    UploadPhotoButtonCtrl.$inject = ['$element'];

    function UploadPhotoButtonCtrl($element) {
        var ctrl = this;

        ctrl.$onInit = $onInit;
        ctrl.openFileDialog = openFileDialog;
        ctrl.onFileLoaded = onFileLoaded;
        ctrl.onFileError = onFileError;

        ctrl.uploadInputId = uniqueId();
        ctrl.fileObj = undefined;

        function $onInit() {
            ctrl.accept = ctrl.accept || 'image/*';
            ctrl.maxSize = ctrl.maxSize || 5242880;
            ctrl.errorMessage = ctrl.errorMessage || 'File might be too big or the format is not allowed';
        }

        function openFileDialog() {
            angular.element(document.getElementsByClassName(ctrl.uploadInputId)).click();
        }

        function onFileLoaded(fileObj) {
            return ctrl.onFile && ctrl.onFile({ file: fileObj });
        }

        function onFileError() {
            return ctrl.onError && ctrl.onError({ message: ctrl.errorMessage });
        }
    }

    function uniqueId() {
        return 'upload_' + Math.random().toString(16).substr(2);
    }
})();
